import { render } from "./QuestionBadge.vue?vue&type=template&id=4b07b432&scoped=true"
import script from "./QuestionBadge.vue?vue&type=script&lang=js"
export * from "./QuestionBadge.vue?vue&type=script&lang=js"

import "./QuestionBadge.vue?vue&type=style&index=0&id=4b07b432&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b07b432"]])

export default __exports__